import { render, staticRenderFns } from "./NbzRules.vue?vue&type=template&id=8d235fe8&v-slot%3AnbzRules=true&"
import script from "./NbzRules.vue?vue&type=script&lang=ts&"
export * from "./NbzRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports